import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function EmojiScaleField({ label, required, properties }: FieldRendererProps) {
  const emojis = properties.emojis ?? [];

  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <div className="flex gap-3">
        {emojis.map((item) => (
          <button
            key={item.value}
            type="button"
            className="flex flex-col items-center gap-1 rounded-lg border p-2 transition-colors hover:bg-accent"
          >
            <span className="text-2xl">{item.emoji}</span>
            <span className="text-xs text-muted-foreground">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
